import { env } from "./EnvironmentConfig";

export const ENTRY_ROUTE = "/auth/login";
export const ERROR_NOT_FOUND_ROUTE = "/errors/404";
export const TOKEN_PAYLOAD_KEY = "authorization";
export const ORGANIZATION_API_PATH = env.API_ENDPOINT_BASE_URL;

export const CAPTCHA_SITE_KEY = env.H_CAPTCHA_SITE_KEY;
